// Vuetify Documentation https://vuetifyjs.com

import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "@fortawesome/fontawesome-free/css/all.css";

import { VCol, VRow } from "vuetify/lib";

Vue.use(Vuetify, {
  components: {
    VCol,
    VRow
  }
});

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#404040",
        secondary: "#7B1FA2",
        accent: "#B22AF0",
        app: "#7B1FA2",
        material: "#AB47BC",
        other: "#F8955B",
        original: "#F29E4D",
        boss: "#58356E",
        tan: "#F8955B",
        lgrey: "#F7F7F7",
        offblack: "#201A23",
        purple: "#8531A9",
      },
      dark: {}
    }
  }
});
